export const CA = "JeA7zwqJGnjN46PkqPJHzSBLwSGsACJC2pMf37d96CY";
export const PUMP_URL = "https://pump.fun/coin/JeA7zwqJGnjN46PkqPJHzSBLwSGsACJC2pMf37d96CY";
export const X_URL = "https://x.com/pusheencatfans";
export const TELEGRAM_URL = "https://t.me/pusheenmemessol";
export const TIKTOK_URL = "https://www.tiktok.com/@pusheencatfans";

export const ASSETS = {
  logo: "/cats/logo.png",
  headerLogo: "/cats/noodle-logo.png",
  bg: "https://customer-assets.emergentagent.com/job_pusheen-legend/artifacts/c1si2wkd_24CCB951-AFC6-4208-AADC-99CF0B881B94.png",
  wordmarkScene: "https://customer-assets.emergentagent.com/job_6a41ab93-df2f-46ec-b678-7c2998a0594b/artifacts/xfxuaxl4_24CCB951-AFC6-4208-AADC-99CF0B881B94.png",
};

export const CATS = {
  wave: "/cats/wave.png",
  heart: "/cats/heart.png",
  donut: "/cats/donut.png",
  cookie: "/cats/cookie.png",
  sleep: "/cats/sleep.png",
  paw: "/cats/paw.png",
};

const G = "/cats/gallery";
export const GALLERY = [
  { src: `${G}/IMG_7105.webp`, title: "Hello There", caption: "The wave that started 60 billion smiles." },
  { src: `${G}/IMG_7104.webp`, title: "Full of Love", caption: "Wholesome levels: maximum." },
  { src: `${G}/IMG_7110.webp`, title: "Snacc Attack", caption: "Who ate the cookies? Me. I did." },
  { src: `${G}/IMG_7108.webp`, title: "Slurrrp", caption: "Spaghetti speedrun, any%." },
  { src: `${G}/IMG_7106.webp`, title: "Too Cool", caption: "Deal with it, nya." },
  { src: `${G}/IMG_7107.webp`, title: "WFH Chonk", caption: "Grinding the charts from bed." },
  { src: `${G}/IMG_7102.webp`, title: "Burger Buddy", caption: "Chonk on a bun." },
  { src: `${G}/IMG_7103.webp`, title: "Noodle Time", caption: "Slurpin' toward billions." },
  { src: `${G}/IMG_7109.webp`, title: "Naptime", caption: "Zzz... dreaming of billions." },
];
